module.exports = __webpack_public_path__ + "img/marc_lochtermann.60ea4a67.png";